module.exports = __webpack_public_path__ + "images/37666d9127c6732293c865dd71e5bbf1.png";